import * as React from "react";
import { frontEndConfig } from "src/config/config";
import { stars } from "src/presentation/component/client/customer/stars";
import styled from "styled-components";
import { customerConfig } from "../../../../config/language/ja-JP/domain/model_text";
import { ConstBreakPoint } from "../../../../config/styles_const/styles_const";
import { Company } from "../../../../domain/model/company";
import { Customer, Status } from "../../../../domain/model/customer";
import AvatarLarge from "../../../common/atom/avatar/avatar_large";

interface IProps {
  customer: Customer;
  company: Company | null;
  avarageReviewPoint: number;
  onTapReviewLink: () => void;
}

const CustomerProfile: React.FC<IProps> = (props) => {
  const { customer, company, avarageReviewPoint, onTapReviewLink } = props;
  const ellipsisWith = 270;
  const [ellipsis, setEllipsis] = React.useState<boolean>(
    customer.pr.length > ellipsisWith
  );

  return (
    <React.Fragment>
      <Wrapper>
        <Section>
          <div>
            <AvatarLarge src={customer.getIconURL()} />
            <div
              style={{
                color: "#A4A4A4",
                textAlign: "center",
                marginTop: 10,
                fontSize: 12,
              }}
            >
              {customerConfig.genderList.get(customer.gender)}/
              {customer.getAgeString()}
            </div>
            <div
              style={{
                textAlign: "center",
                marginTop: 10,
              }}
            >
              {company != null &&
                company.isAdmin &&
                customer.status !== Status.Status_Active && (
                  <div
                    style={{
                      display: "inline-block",
                      paddingTop: 3,
                      paddingBottom: 3,
                      textAlign: "center",
                      width: 100,
                      fontSize: 10,
                      lineHeight: "15px",
                      fontWeight: "bold",
                      color: "white",
                      backgroundColor: "#CE4141",
                      borderRadius: 21,
                    }}
                  >
                    {customerConfig.statusList.get(customer.status)}
                  </div>
                )}
            </div>

            {!isNaN(avarageReviewPoint) && (
              <>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-end",
                    width: 180,
                    marginLeft: 10,
                  }}
                >
                  {stars(avarageReviewPoint)}
                  <div
                    style={{
                      color: "#a4a4a4",
                      fontWeight: "bold",
                      fontSize: 10,
                      marginLeft: 5,
                    }}
                  >
                    ({avarageReviewPoint.toFixed(2)})
                  </div>
                </div>
                <div
                  onClick={onTapReviewLink}
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: 12,
                    color: "#9A8C64",
                    marginTop: 10,
                    cursor: "pointer",
                  }}
                >
                  口コミ評価をみる
                </div>
              </>
            )}

            {company && company.isAdmin && (
              <div style={{ marginTop: 10 }}>
                <a
                  style={{
                    color: "#F13333",
                    fontSize: 12,
                    fontWeight: "bold",
                    display: "block",
                    textAlign: "center",
                  }}
                  href={`${frontEndConfig.adminURL}/customer/${customer.id}`}
                  target="_blank"
                >
                  Adminはこちらをクリック
                </a>
              </div>
            )}
          </div>
          <div style={{ marginLeft: 40 }}>
            <JobCareerCatchphraseLabel>
              {customer.jobCareerCatchphrase}
            </JobCareerCatchphraseLabel>
            <JobCareerCatchphrase>{customer.catchphrase}</JobCareerCatchphrase>
            <Catchphrase>
              {ellipsis
                ? `${customer.pr.slice(0, ellipsisWith)}...`
                : customer.pr}
            </Catchphrase>
          </div>
        </Section>
      </Wrapper>

      {ellipsis && (
        <ReadMore
          onClick={() => {
            setEllipsis(false);
          }}
        >
          全て表示
        </ReadMore>
      )}
    </React.Fragment>
  );
};

export default CustomerProfile;

const Wrapper = styled.div`
  margin: 40px auto;
`;

const Section = styled.div`
  display: block;
  text-align: center;
  margin-bottom: 40px;
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    display: flex;
    text-align: left;
  }
`;

const Text = styled.div`
  margin-top: 50px;
  font-size: 12px;
  font-weight: normal;
  line-height: 15px;
  white-space: pre-wrap;
`;

const JobCareerCatchphraseLabel = styled.div`
  color: #333333;
  font-size: 12px;
  font-weight: bold;
  line-height: 18px;
  white-space: pre-wrap;
  margin-top: 20px;
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    margin-top: 0px;
  }
`;

const JobCareerCatchphrase = styled.div`
  color: #333333;
  font-size: 26px;
  font-weight: bold;
  line-height: 42px;
  white-space: pre-wrap;
`;

const Catchphrase = styled.div`
  color: #333333;
  margin-top: 15px;
  font-size: 15px;
  font-weight: normal;
  line-height: 24px;
  white-space: pre-wrap;
`;

const ButtonWrapper = styled.div`
  margin-left: 10px;
`;

const EditButtonContainer = styled.div`
  display: none;
  margin-top: 40px;
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    display: block;
    margin-top: 0px;
  }
`;

const ReadMore = styled.div`
  width: 130px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  margin: 18px auto;
  background-color: #eeeeee;
  border-radius: 30px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
`;



// WEBPACK FOOTER //
// ./src/presentation/component/client/customer/customer_profile.tsx